module.exports = __webpack_public_path__ + "assets/favicon-180.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon-180.png
// module id = 154
// module chunks = 0